import { Fragment, useEffect, useMemo, useState } from 'react';
import { Dashboard, logo_card, noData } from '../../../components/ExportImgFigma';
import '../styles.scss';

// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import { ConfigProvider, DatePicker, Input, Pagination, Tabs } from 'antd';

import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import { ColDef } from 'ag-grid-community';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import { ListField } from '../../../api/Customer_V2/customerApi_V2';
import { ICustomerFields } from '../../../api/salesSericeCustomer/salesSericeCustomerApi';
import useDebounce from '../../../hook/useDebounce';
import useToast from '../../../hook/useToast';
import { getWidthFromHeader, renderValueAsJSX } from '../../../until';
import { ColumnKey } from '../../Customers/Tabs/CarListCardClone';
import { FlattenedField } from '../../CustomersV2/indexV2';
import StatusCellRenderer from '../../VehicleManagement/VehicleTypeManagement/Component/StatusCellRenderer';
import TabsFeilds from '../Modal/TabsFeilds';
import { TabsProps } from 'antd/lib';
import ServiceMaintenanceInvoiceDetail from './ServiceMaintenanceInvoiceDetail';
import { formatNumber } from '../../../services/mixin';
dayjs.locale('vi');

const { RangePicker } = DatePicker;


const dataListFieldsByCustomerRecordActive = [
  {
    "id": 1,
    "title": "Hoá đơn xe",
    "fields": [
      {
        "id": 1,
        "fieldCode": "representative",
        "fieldLabel": "Người đại diện",
        "inputType": "string",
        "isActive": 1
      },
      {
        "id": 2,
        "fieldCode": "carName",
        "fieldLabel": "Tên xe",
        "inputType": "string",
        "isActive": 1
      },
      {
        "id": 3,
        "fieldCode": "vin",
        "fieldLabel": "Số khung (VIN)",
        "inputType": "string",
        "isActive": 1
      },
      {
        "id": 4,
        "fieldCode": "licensePlate",
        "fieldLabel": "Biển số xe",
        "inputType": "string",
        "isActive": 1
      },
      {
        "id": 5,
        "fieldCode": "color",
        "fieldLabel": "Màu xe",
        "inputType": "string",
        "isActive": 1
      },
      {
        "id": 6,
        "fieldCode": "total",
        "fieldLabel": "Tổng tiền",
        "inputType": "number",
        "isActive": 1
      },
      {
        "id": 7,
        "fieldCode": "invoiceNumber",
        "fieldLabel": "Số hóa đơn",
        "inputType": "string",
        "isActive": 1
      },
      {
        "id": 8,
        "fieldCode": "invoiceDate",
        "fieldLabel": "Ngày xuất hóa đơn",
        "inputType": "date",
        "isActive": 1
      },
      {
        "id": 9,
        "fieldCode": "buyerUnit",
        "fieldLabel": "Đơn vị mua xe",
        "inputType": "string",
        "isActive": 1
      },
      {
        "id": 10,
        "fieldCode": "dealer",
        "fieldLabel": "Điểm bán hàng",
        "inputType": "string",
        "isActive": 1
      }
    ]


  }
]

const dataListFieldsByCustomerRecordNotActive = [
  {
    "id": 1,
    "title": "Hoá đơn xe",
    "fields": [
    ]
  }
]


const rowData = [
  {
    id: 1,
    representative: "Minh Anh",
    carName: "New Carnival 2.2D Signature 7S",
    vin: "RNHA43TNART090850",
    licensePlate: "65C22983",
    color: "Trắng",
    total: "14.638.000",
    invoiceNumber: "0001226",
    invoiceDate: "21/02/2022",
    buyerUnit: "THACO AUTO Cần Thơ (T36)",
    dealer: "CN Vĩnh Long (DL) - 65601021"
  },
  {
    id: 2,
    representative: "Tấn Tài",
    carName: "New Mazda CX-8 2.5 Luxury",
    vin: "RNHA14SSCRT096303",
    licensePlate: "64A00515",
    color: "Trắng",
    total: "24.638.000",
    invoiceNumber: "0001226",
    invoiceDate: "21/02/2022",
    buyerUnit: "THACO AUTO Cần Thơ (T36)",
    dealer: "CN Vĩnh Long (DL) - 65601021"
  },
  {
    id: 3,
    representative: "Huỳnh Lộc",
    carName: "FUSO-FI170",
    vin: "RNHV22TGART087716",
    licensePlate: "51K35645",
    color: "Trắng",
    total: "14.638.000",
    invoiceNumber: "0001226",
    invoiceDate: "21/02/2022",
    buyerUnit: "THACO AUTO Cần Thơ (T36)",
    dealer: "CN Vĩnh Long (DL) - 65601021"
  }
];

const columnDefs = [
  { headerName: "Người đại diện", field: "representative", flex: 1.5, sortable: true },
  { headerName: "Tên xe", field: "carName", flex: 2, sortable: true },
  { headerName: "Số khung (VIN)", field: "vin", flex: 2, sortable: true },
  { headerName: "Biển số xe", field: "licensePlate", flex: 1, sortable: true },
  { headerName: "Màu xe", field: "color", flex: 1 },
  { headerName: "Tổng tiền", field: "total", flex: 1, sortable: true },
  { headerName: "Số hóa đơn", field: "invoiceNumber", flex: 1, sortable: true },
  { headerName: "Ngày xuất hóa đơn", field: "invoiceDate", flex: 1.2, sortable: true },
  { headerName: "Đơn vị mua xe", field: "buyerUnit", flex: 2 },
  { headerName: "Điểm bán hàng", field: "dealer", flex: 2 }
];



const generateColumnsFromCodesAgGridReact = (
  codes: ColumnKey[],
  fields: ICustomerFields[],
  actionColumn?: ColDef<any, any>,
  onToggleStatus?: (id: number, next: boolean, rowData: any) => void, // thêm callback
): ColDef[] => {
  const baseColumns = codes
    ?.map(code => {
      const field = fields.find(f => f.fieldCode === code)
      if (!field) return null
      if (field.fieldCode === "status") {
        return {
          headerName: field.fieldLabel,
          field: field.fieldCode,
          colId: field.fieldCode,
          sortable: true,
          cellRenderer: StatusCellRenderer,
          cellRendererParams: {
            onToggle: (id: number, next: boolean, rowData: any) => {
              if (onToggleStatus) {
                onToggleStatus(id, next, rowData)
              }
            },
            idKey: 'key'
          }
        }
      }

      return {
        headerName: field.fieldLabel,
        field: field.fieldCode,
        colId: field.fieldCode,
        sortable: true,
        width: getWidthFromHeader(field.fieldLabel),
        cellRenderer: (params: any) => renderValueAsJSX(params.value,field.fieldCode)
      } as ColDef
    })
    .filter(Boolean) as ColDef[]

  return actionColumn ? [actionColumn, ...baseColumns] : baseColumns
}

export default function ServiceMaintenanceInvoice({ stData = {} as any, stChange = (data: any) => { } }) {

  const pushToast = useToast();

  const [isSettingShow, setSettingShow] = useState(false)

  const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([])
  const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([])

  const [ColumnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])

  const [demoList, setDemoList] = useState<any[]>([])
  const [rowHeight, setRowHeight] = useState(40)


  const onChange = (key: string) => {
    // setIsTab(Number(key));
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <span className='custom-page-css font-light text-lg'>Chi tiết</span>,
      children: <ServiceMaintenanceInvoiceDetail stData={stData} />,
    },
  ];


  useEffect(() => {
    gListFieldsActive()
    gList()


    const handleResize = () => {
      const baseFactor = (48 * 100) / 1440 / 100
      const factor = window.innerWidth > 1440 ? baseFactor * 0.9 : baseFactor
      const newHeight = Math.round(window.innerWidth * factor)
      setRowHeight(newHeight)
    }
    handleResize()

    window.addEventListener('resize', handleResize)

    return (() => {
      // setPagination({ current: 1, pageSize: 20, total: 0 })
      // setSelectedRowKeys([])
      window.removeEventListener('resize', handleResize)
    })
  }, [])

  const gList = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {

    setDemoList(rowData)
  }, 1000)

  const [activeEyeId, setActiveEyeId] = useState<string | number | null>(null);
  const actionColumn: ColDef = {
    headerName: 'Hành động',
    field: 'action',
    colId: 'action',
    // width: getWidthFromHeader('Hành động'),
    cellRenderer: (params: any) => {
      // const { view, edit, delete: isDelete } = params?.data?.permissionMenu
      return (
        <div className='d-flex gap-4 justify-start align-center  h-full'>

          <EyeOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer fs-14 border-8px${activeEyeId === params.data.id ? " active" : ""
              }`}
            onClick={() => {
              setActiveEyeId(params.data.id);
              stChange({ chitietdichvu: [{ ...params?.data }] })
            }}
          />
        </div>

      )
    },
  }


  const gListFieldsActive = async () => {
    const flattenedFields = await dataListFieldsByCustomerRecordActive.flatMap(choice =>
      choice.fields.map(field => ({
        ...field,
        parentId: choice.id,
      }))
    );
    setDataFilterActive(flattenedFields)


    gListFieldsNotActive()
  }
  const gListFieldsNotActive = async () => {
    setDataFilterNoActive(dataListFieldsByCustomerRecordNotActive)


  }
  const onSaveDataFields = (iSsuccess?: boolean, message?: string, dataFilterActive?: FlattenedField[], dataFilterNoActive?: ListField[]) => {
    if (iSsuccess) {
      setSettingShow(false)
      pushToast(message, "success")
      setDataFilterActive(dataFilterActive ?? [])
      setDataFilterNoActive(dataFilterNoActive ?? [])
      gList()

    } else {
      pushToast(message, "warning")
    }
  }

  const onCloseDataFields = () => {
    setSettingShow(false)
  }

  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReact(
      ColumnsMapShow, dataFilterActive, actionColumn,
      (id: number, next: boolean, rowData: any) => console.log(id, next, rowData)

    );
  }, [ColumnsMapShow]);

  useEffect(() => {
    const codes = dataFilterActive.map(f => f.fieldCode)
    setColumnsMapShow(codes)
  }, [dataFilterActive])

  return (
    <Fragment>
      <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 pt-3">
        <div className={` w-full`}>
          <div className="ag-theme-alpine custom-table-ag" style={{ width: '100%' }}>
            <AgGridReact<any>
              rowData={stData.vehicle_owner_total_service || []}
              columnDefs={[
                actionColumn,
                { field: "own_accu_seri", headerName: "AccSeri1" },
                { field: "own_branch_name", headerName: "Đơn vị" },
                { field: "own_chassis_no", headerName: "Số khung" },
                { field: "own_color_name", headerName: "Màu xe" },
                { field: "own_engine_no", headerName: "Số máy" },
                { field: "own_made_year", headerName: "Năm sản xuất" },
                { field: "own_number_plate", headerName: "Biển số" },
                { field: "own_purchase_date", headerName: "Ngày mua" },
                { field: "own_route_name", headerName: "Chi nhánh" },
                { field: "own_vehicle_brand", headerName: "Hãng xe" },
                { field: "own_vehicle_model", headerName: "Mẫu xe" },
                { field: "own_vehicle_name", headerName: "Tên xe" },
                { field: "repair_total_amount", headerName: "Tổng doanh thu sửa chữa xe" },
              ]}
              domLayout="autoHeight"
              className="my-auto-height-grid"
              rowHeight={55}
              getRowStyle={(params: any) => ({
                backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
              })}
              overlayNoRowsTemplate={`
                           <div style="text-align: center; padding: 20px;">
                           <br />
                               <img src="${noData}" alt="No data" style="max-width: 150px;" />
                           <br />
                               <div>Không có dữ liệu</div>
                           <br />
                           </div>
                           `}
            />

          </div>
          <ConfigProvider locale={viVN}>
            <div className="pagination-block">
              <Pagination
                showSizeChanger
                //   pageSize={pagination.pageSize}
                //   total={pagination.total}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                //   showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                className='rs-pagination'
              //   onChange={onPaginationChange}

              />
            </div>
          </ConfigProvider>
        </div>
        <div className="custom-page-css w-full flex items-center justify-between gap-3 pt-3 relative">
          <Tabs defaultActiveKey="1" items={items} onChange={onChange} className='w-full' />
        </div>
      </div>
    </Fragment>
  )

}
